import { render, staticRenderFns } from "./ApiButton.vue?vue&type=template&id=2f4daa26"
import script from "./ApiButton.vue?vue&type=script&lang=ts"
export * from "./ApiButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports